// constants/mockDeduplicationResponse.ts

export const mockDeduplicationResponse = {
    duplicateBundles: [
        [
            {
                media_id1: 'JWSLo0b19FXXY9PPdMXdEVHImW6zt9xd',
                media_id2: 'qTTRx2SdLtMAns1xO9KqI2sREhkYgTKG',
                similarity: 0.92,
            },
            {
                media_id1: 'JWSLo0b19FXXY9PPdMXdEVHImW6zt9xd',
                media_id2: 'DhjrBskX7IyymRFnH3qS9SJTEE3rNNsq',
                similarity: 0.85,
            },
        ],
        [
            {
                media_id1: 'FPIW37o3RnZQNt1lqpAVti7P9HQgokt3',
                media_id2: 'fcLISynkED4slYAZIqZCOq56uiEjYpQe',
                similarity: 0.78,
            },
        ],
        [
            {
                media_id1: 'OG6lZwG6jG6nW1w2L42X4nvkxa0Urvpf',
                media_id2: 'TC0IiELDNtnNgZcDcPKL00stn1exuLOn',
                similarity: 0.89,
            },
        ],
    ],
    duplicate_clusters: [
        {
            cluster_id: 1,
            size: 3,
            videos: [
                {
                    media_id: 'JWSLo0b19FXXY9PPdMXdEVHImW6zt9xd',
                    title: 'DOK Narben der Gewalt, Ultras Basel',
                    secondary_title: 'Dokumentation',
                    description: 'Eine Dokumentation über die Ultras Basel und die Gewalt im Fussball. Der Film zeigt die verschiedenen Facetten der Fankultur.',
                    duration: '01:20:00',
                    languages: ['Deutsch'],
                    mediaCountriesOrigin: ['CH'],
                    mediaCreationDate: '2011',
                    links: [
                        {
                            href: '/api/v1/media/JWSLo0b19FXXY9PPdMXdEVHImW6zt9xd/overview',
                            rel: 'media/overview'
                        },
                        {
                            href: 'https://www.nanoo.tv/still-img/356/35356_03.jpg',
                            rel: 'media/preview/thumbnail'
                        },
                        {
                            href: 'https://www.nanoo.tv/still-img/356/35356_03.jpg',
                            rel: 'media/preview/thumbnail/x2'
                        }
                    ],
                    similar_videos: [
                        {
                            media_id: 'qTTRx2SdLtMAns1xO9KqI2sREhkYgTKG',
                            title: 'Die Schwarze Spinne',
                            similarity: 0.92,
                        },
                        {
                            media_id: 'DhjrBskX7IyymRFnH3qS9SJTEE3rNNsq',
                            title: 'Die schwarzen Brüder',
                            similarity: 0.85,
                        },
                    ],
                },
                {
                    media_id: 'qTTRx2SdLtMAns1xO9KqI2sREhkYgTKG',
                    title: 'Die Schwarze Spinne',
                    secondary_title: 'Schweizer Film',
                    description: 'Verfilmung der berühmten Novelle von Jeremias Gotthelf über einen Pakt mit dem Teufel.',
                    duration: '01:51:18',
                    languages: ['Deutsch'],
                    mediaCountriesOrigin: ['CH'],
                    mediaCreationDate: '2022',
                    links: [
                        {
                            href: '/api/v1/media/qTTRx2SdLtMAns1xO9KqI2sREhkYgTKG/overview',
                            rel: 'media/overview'
                        },
                        {
                            href: 'https://www.nanoo.tv/still-img/077/1236077_02_full.jpg',
                            rel: 'media/preview/thumbnail'
                        },
                        {
                            href: 'https://www.nanoo.tv/still-img/077/1236077_02_full.jpg',
                            rel: 'media/preview/thumbnail/x2'
                        }
                    ],
                    similar_videos: [
                        {
                            media_id: 'JWSLo0b19FXXY9PPdMXdEVHImW6zt9xd',
                            title: 'DOK Narben der Gewalt, Ultras Basel',
                            similarity: 0.92,
                        },
                        {
                            media_id: 'DhjrBskX7IyymRFnH3qS9SJTEE3rNNsq',
                            title: 'Die schwarzen Brüder',
                            similarity: 0.88,
                        },
                    ],
                },
                {
                    media_id: 'DhjrBskX7IyymRFnH3qS9SJTEE3rNNsq',
                    title: 'Die schwarzen Brüder',
                    secondary_title: 'Familienfilm',
                    description: 'Nach dem Roman von Lisa Tetzner über Tessiner Kinder, die als Kaminfeger nach Mailand verkauft wurden.',
                    duration: '01:44:08',
                    languages: ['Deutsch', 'Italienisch'],
                    mediaCountriesOrigin: ['IT', 'DE', 'CH'],
                    mediaCreationDate: '2014',
                    links: [
                        {
                            href: '/api/v1/media/DhjrBskX7IyymRFnH3qS9SJTEE3rNNsq/overview',
                            rel: 'media/overview'
                        },
                        {
                            href: 'https://www.nanoo.tv/still-img/406/527406_01.jpg',
                            rel: 'media/preview/thumbnail'
                        },
                        {
                            href: 'https://www.nanoo.tv/still-img/406/527406_01.jpg',
                            rel: 'media/preview/thumbnail/x2'
                        }
                    ],
                    similar_videos: [
                        {
                            media_id: 'JWSLo0b19FXXY9PPdMXdEVHImW6zt9xd',
                            title: 'DOK Narben der Gewalt, Ultras Basel',
                            similarity: 0.85,
                        },
                        {
                            media_id: 'qTTRx2SdLtMAns1xO9KqI2sREhkYgTKG',
                            title: 'Die Schwarze Spinne',
                            similarity: 0.88,
                        },
                    ],
                },
            ],
        },
        {
            cluster_id: 2,
            size: 2,
            videos: [
                {
                    media_id: 'FPIW37o3RnZQNt1lqpAVti7P9HQgokt3',
                    title: 'Die Reise zum sichersten Ort der Erde',
                    secondary_title: 'Dokumentarfilm',
                    description: 'Ein Dokumentarfilm über die weltweite Suche nach einem sicheren Endlager für radioaktiven Abfall.',
                    duration: '01:41:22',
                    languages: ['Deutsch', 'Englisch'],
                    mediaCountriesOrigin: ['CH', 'AU', 'AT'],
                    mediaCreationDate: '2013',
                    links: [
                        {
                            href: '/api/v1/media/FPIW37o3RnZQNt1lqpAVti7P9HQgokt3/overview',
                            rel: 'media/overview'
                        },
                        {
                            href: 'https://www.nanoo.tv/still-img/618/282618_01.jpg',
                            rel: 'media/preview/thumbnail'
                        },
                        {
                            href: 'https://www.nanoo.tv/still-img/618/282618_01.jpg',
                            rel: 'media/preview/thumbnail/x2'
                        }
                    ],
                    similar_videos: [
                        {
                            media_id: 'fcLISynkED4slYAZIqZCOq56uiEjYpQe',
                            title: 'Die Pazifistin - Gertrud Woker',
                            similarity: 0.78,
                        },
                    ],
                },
                {
                    media_id: 'fcLISynkED4slYAZIqZCOq56uiEjYpQe',
                    title: 'Die Pazifistin - Gertrud Woker - eine vergessene Heldin',
                    secondary_title: 'Biografie',
                    description: 'Dokumentarfilm über Gertrud Woker, eine Schweizer Chemikerin und Friedensaktivistin.',
                    duration: '01:08:54',
                    languages: ['Deutsch'],
                    mediaCountriesOrigin: ['CH'],
                    links: [
                        {
                            href: '/api/v1/media/fcLISynkED4slYAZIqZCOq56uiEjYpQe/overview',
                            rel: 'media/overview'
                        },
                        {
                            href: 'https://www.nanoo.tv/still-img/571/1189571_12.jpg',
                            rel: 'media/preview/thumbnail'
                        },
                        {
                            href: 'https://www.nanoo.tv/still-img/571/1189571_12.jpg',
                            rel: 'media/preview/thumbnail/x2'
                        }
                    ],
                    similar_videos: [
                        {
                            media_id: 'FPIW37o3RnZQNt1lqpAVti7P9HQgokt3',
                            title: 'Die Reise zum sichersten Ort der Erde',
                            similarity: 0.78,
                        },
                    ],
                },
            ],
        },
        {
            cluster_id: 3,
            size: 2,
            videos: [
                {
                    media_id: 'OG6lZwG6jG6nW1w2L42X4nvkxa0Urvpf',
                    title: 'Die letzte Chance',
                    secondary_title: 'Kriegsfilm',
                    description: 'Schweizer Spielfilm von 1945 über Flüchtlinge, die während des Zweiten Weltkriegs in die Schweiz fliehen.',
                    duration: '01:46:24',
                    languages: ['Deutsch', 'Französisch'],
                    mediaCountriesOrigin: ['CH'],
                    mediaCreationDate: '1945',
                    links: [
                        {
                            href: '/api/v1/media/OG6lZwG6jG6nW1w2L42X4nvkxa0Urvpf/overview',
                            rel: 'media/overview'
                        },
                        {
                            href: 'https://www.nanoo.tv/still-img/783/445783_01.jpg',
                            rel: 'media/preview/thumbnail'
                        },
                        {
                            href: 'https://www.nanoo.tv/still-img/783/445783_01.jpg',
                            rel: 'media/preview/thumbnail/x2'
                        }
                    ],
                    similar_videos: [
                        {
                            media_id: 'TC0IiELDNtnNgZcDcPKL00stn1exuLOn',
                            title: 'Die kleine Hexe',
                            similarity: 0.89,
                        },
                    ],
                },
                {
                    media_id: 'TC0IiELDNtnNgZcDcPKL00stn1exuLOn',
                    title: 'Die kleine Hexe - Di chli Häx [2018]',
                    secondary_title: 'Kinderfilm',
                    description: 'Verfilmung des Kinderbuchklassikers von Otfried Preussler über eine kleine Hexe, die gut sein will.',
                    duration: '01:45:19',
                    languages: ['Deutsch', 'Schweizerdeutsch'],
                    mediaCountriesOrigin: ['DE', 'CH'],
                    mediaCreationDate: '2018',
                    links: [
                        {
                            href: '/api/v1/media/TC0IiELDNtnNgZcDcPKL00stn1exuLOn/overview',
                            rel: 'media/overview'
                        },
                        {
                            href: 'https://www.nanoo.tv/still-img/169/640169_10.jpg',
                            rel: 'media/preview/thumbnail'
                        },
                        {
                            href: 'https://www.nanoo.tv/still-img/169/640169_10.jpg',
                            rel: 'media/preview/thumbnail/x2'
                        }
                    ],
                    similar_videos: [
                        {
                            media_id: 'OG6lZwG6jG6nW1w2L42X4nvkxa0Urvpf',
                            title: 'Die letzte Chance',
                            similarity: 0.89,
                        },
                    ],
                },
            ],
        },
    ],
    stats: {
        total_videos: 7,
        duplicate_pairs: 5,
        duplicate_clusters: 3,
        processing_time_seconds: 45.7,
        videos_per_second: 15.3,
        pairs_per_second: 48.2,
        memory_usage_mb: 1024,
        feature_extraction_time: 12.3,
        comparison_time: 28.9,
        clustering_time: 4.5,
    },
    method: 'combined',
    threshold: 0.75,
    timestamp: new Date().toISOString(),
    processing_details: {
        extraction_method: 'deep_learning',
        comparison_algorithm: 'cosine_similarity',
        clustering_algorithm: 'hierarchical',
        cache_hits: 3,
        cache_misses: 4,
        feature_dimensions: 512,
    },
}

// Stage progression data remains the same
export const mockStageProgression = [
    { stage: 'initializing', substage: 'setup', duration: 500, progress: 5 },
    { stage: 'initializing', substage: 'loading_settings', duration: 300, progress: 10 },
    { stage: 'api_fetch', substage: 'fetching_videos', duration: 800, progress: 15 },
    { stage: 'api_fetch', substage: 'parsing_metadata', duration: 400, progress: 20 },
    { stage: 'feature_extraction', substage: 'preparing', duration: 600, progress: 25 },
    { stage: 'feature_extraction', substage: 'extracting', duration: 2000, progress: 50 },
    { stage: 'feature_extraction', substage: 'caching', duration: 400, progress: 55 },
    { stage: 'comparison', substage: 'preparing_pairs', duration: 300, progress: 60 },
    { stage: 'comparison', substage: 'similarity_calculation', duration: 1500, progress: 75 },
    { stage: 'comparison', substage: 'filtering_results', duration: 300, progress: 80 },
    { stage: 'clustering', substage: 'finding_clusters', duration: 600, progress: 85 },
    { stage: 'clustering', substage: 'organizing_clusters', duration: 400, progress: 90 },
    { stage: 'report_generation', substage: 'formatting_output', duration: 300, progress: 95 },
    { stage: 'completed', substage: 'done', duration: 200, progress: 100 },
]

// Activity log entries remain the same
export const mockActivityLogEntries = [
    'Initialisiere Deduplikation für Benutzer',
    'Lade Benutzereinstellungen und Präferenzen',
    'Rufe Videodaten von der API ab',
    'Verarbeite Metadaten für 7 Videos',
    'Starte Merkmalsextraktion mit Deep Learning Modell',
    'Extrahiere visuelle Merkmale für Video 1/7',
    'Extrahiere visuelle Merkmale für Video 2/7',
    'Extrahiere visuelle Merkmale für Video 3/7',
    'Extrahiere visuelle Merkmale für Video 4/7',
    'Extrahiere visuelle Merkmale für Video 5/7',
    'Extrahiere visuelle Merkmale für Video 6/7',
    'Extrahiere visuelle Merkmale für Video 7/7',
    'Speichere extrahierte Merkmale im Cache',
    'Erstelle Vergleichspaare für Ähnlichkeitsberechnung',
    'Berechne Ähnlichkeiten für 21 Videopaare',
    'Filtere Ergebnisse mit Schwellenwert 0.75',
    'Identifiziere Duplikatgruppen mit hierarchischem Clustering',
    'Organisiere 3 Duplikatgruppen mit insgesamt 7 Videos',
    'Erstelle detaillierten Deduplikationsbericht',
    'Deduplikation erfolgreich abgeschlossen',
]